import "@/App.css";

// BookFinder is a pure HTML/CSS/JS single-page app served from /public/bookfinder.
// React shell mounts it full-screen so it works with the platform preview URL.
function App() {
  return (
    <iframe
      title="BookFinder"
      src="/bookfinder/index.html"
      data-testid="bookfinder-frame"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}

export default App;
